import { changeFlip, updateBubbleControlPoint, updateCurrentSlideThumbnail } from '../../actions/CurrentSlideActions';
import saveManager from '../utils/SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import React from 'react';
import { SecondaryMenuButton } from './SizeAndPositionButtons';
import locales from '../../locales/LocalesManager';
import storeManager from '../../store/StoreManager';
import shapeConstants from '../../constants/ShapeConstants';

export const FlipView = React.createClass({
    getContextTarget() {
        const shapes = storeManager.getState().currentSlide.model.content;

        for (let i = 1; i < shapes.length; i++) {
            if (shapes[i].uuid === this.props.shapeModel.uuid)
                return shapes[i];
        }

        return this.props.shapeModel;
    },
    changeFlip(flipType) {
        const shapeModel = this.getContextTarget();

        if (!shapeModel)
            return;

        //Update the voice arrow on speaking bubbles
        if( shapeModel.type === shapeConstants.SPEAK_BUBBLE || shapeModel.type === shapeConstants.COMPLEX_SPEAK_BUBBLE || shapeModel.type === shapeConstants.THOUGHT_BUBBLE || shapeModel.type === shapeConstants.SCREAM_BUBBLE) {
            let newCx = shapeModel.cx;
            let newCy = shapeModel.cy;

            if(flipType === "horizontalFlip"){
                newCx = shapeModel.x + shapeModel.width -(shapeModel.cx - shapeModel.x)
                this.props.dispatch(updateBubbleControlPoint(shapeModel.uuid, newCx, newCy));
            }
            else{//verticalFlip
                //newCy = shapeModel.y + shapeModel.y + shapeModel.width - shapeModel.cy;
                newCy = shapeModel.y + shapeModel.height -(shapeModel.cy - shapeModel.y)
                this.props.dispatch(updateBubbleControlPoint(shapeModel.uuid, newCx, newCy));
            }
        }
        else {
            this.props.dispatch(changeFlip(shapeModel.uuid, flipType));
        }

        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();
        this.props.dispatch(updateCurrentSlideThumbnail(true));
        this.forceUpdate();
    },
    render() {
        const smallTextStyle = {
            fontSize: '12px',
            marginTop: '15px',
            marginBottom: '-5px'
        };

        const buttonWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            justifyContent: 'space-between'
        };

        return (
            <div>
                <h3 style={smallTextStyle}>{locales.getCaption('Reflect', 'sizePosMenu')}</h3>

                <div style={buttonWrapperStyle}>
                    <SecondaryMenuButton clickHandler={this.changeFlip} type={'horizontalFlip'} caption={locales.getCaption('FlipHorizontal', 'sizePosMenu')}/>
                    <SecondaryMenuButton id="resizeLastItem" clickHandler={this.changeFlip} type={'verticalFlip'} caption={locales.getCaption('FlipVertical', 'sizePosMenu')}/>
                </div>
            </div>
        )
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/FlipView.js
 **/